const styles = {
  container: {
    backgroundColor: '#f3f4f6',
    padding: '20px',
    fontFamily: 'sans-serif',
  },
  mainCard: {
    maxWidth: '672px',
    margin: '0 auto',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  warningBox: {
    marginBottom: '16px',
    padding: '12px',
    backgroundColor: '#fef3cd',
    border: '1px solid #f59e0b',
    borderRadius: '6px',
  },
  warningText: {
    fontSize: '14px',
    color: '#92400e',
    margin: 0,
  },
  inputGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    flex: '1',
    minWidth: '200px',
    padding: '8px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '14px',
  },
  button: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'background-color 0.2s ease',
  },
  buttonGreen: {
    backgroundColor: '#10b981',
  },
  buttonRed: {
    backgroundColor: '#ef4444',
  },
  buttonBlue: {
    backgroundColor: '#3b82f6',
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  video: {
    width: '100%',
    height: '400px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    margin: '20px 0',
    backgroundColor: 'black',
    objectFit: 'cover',
  },
  statusBox: {
    padding: '10px',
    backgroundColor: '#f9fafb',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    height: '100px',
    overflowY: 'auto',
    fontFamily: 'monospace',
    fontSize: '12px',
    whiteSpace: 'pre-wrap',
  },
};

export default styles;
